function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { computed, defineComponent, onMounted, provide, reactive, ref, watch, h } from '@vue/composition-api';
import { withInstall } from '../util';
import { createNamespace } from '../util/create';
import Sticky from '../sticky';
import "../style/components/tabs.css";

var _createNamespace = createNamespace('tabs'),
    _createNamespace2 = _slicedToArray(_createNamespace, 2),
    name = _createNamespace2[0],
    bem = _createNamespace2[1];

export var tabsProps = {
  active: {
    type: [String, Number],
    "default": 0
  },
  hideLine: {
    type: Boolean,
    "default": false
  },
  scroll: {
    type: Boolean,
    "default": true
  },
  scrollAnimate: {
    type: Boolean,
    "default": true
  },
  scrollSpeed: {
    type: Number,
    "default": 5
  },
  fill: {
    type: Boolean,
    "default": true
  },
  theme: {
    type: String,
    "default": 'light'
  },
  lazyRender: {
    type: Boolean,
    "default": true
  },
  sticky: {
    type: Boolean,
    "default": false
  },
  offsetTop: {
    type: Number,
    "default": 0
  },
  swiperable: {
    type: Boolean,
    "default": false
  },
  swiperType: {
    type: Number,
    "default": 1
  },
  isRtl: {
    type: Boolean,
    "default": false
  }
};
export var TABS_KEY = Symbol(name);
var Tabs = defineComponent({
  name: name,
  model: {
    prop: 'active',
    event: 'update'
  },
  props: tabsProps,
  slots: ['default'],
  emits: ['update', 'disabled', 'click', 'rendered', 'change', 'scroll'],
  setup: function setup(props, _ref) {
    var slots = _ref.slots,
        root = _ref.root,
        refs = _ref.refs,
        emit = _ref.emit;
    var state = reactive({
      // 指的是<tabs>XXXX</tabs> 中的XXX
      tabList: [],
      currentIndex: -1,
      inited: false
    });

    var getTabName = function getTabName(tab) {
      return tab.name;
    };

    var currentName = computed(function () {
      var activeTab = state.tabList[state.currentIndex];

      if (activeTab) {
        return getTabName(activeTab);
      }
    });

    var initTabs = function initTabs() {
      updateChildrenTablist();
    };

    watch(function () {
      return props.active;
    }, function (value) {
      if (value !== currentName.value) {
        setCurrentIndexByName(props.active);
      }
    });
    var flag = ref(1);

    var updateChildrenTablist = function updateChildrenTablist() {
      var _getTabs;

      if (((_getTabs = getTabs()) === null || _getTabs === void 0 ? void 0 : _getTabs.length) === 0) {
        return;
      }

      flag.value++;
      root.$nextTick(function () {
        var _getTabs2;

        state.tabList = [];
        (_getTabs2 = getTabs()) === null || _getTabs2 === void 0 ? void 0 : _getTabs2.forEach(function (pane, index) {
          var _pane$componentInstan;

          var paneProps = (_pane$componentInstan = pane.componentInstance) === null || _pane$componentInstan === void 0 ? void 0 : _pane$componentInstan.$props;
          state.tabList.push({
            name: paneProps === null || paneProps === void 0 ? void 0 : paneProps.name,
            title: paneProps === null || paneProps === void 0 ? void 0 : paneProps.title,
            paneInstance: pane === null || pane === void 0 ? void 0 : pane.componentInstance,
            disabled: (paneProps === null || paneProps === void 0 ? void 0 : paneProps.disabled) || false
          });
        });
        setCurrentIndexByName(props.active);
        root.$nextTick(function () {
          setRefs();
          state.inited = true;
        });
      });
    }; // 获取tabs下的所有pane实例


    var getTabs = function getTabs() {
      var _slots$default;

      return ((_slots$default = slots["default"]) === null || _slots$default === void 0 ? void 0 : _slots$default.call(slots).filter(function (item) {
        var _item$componentOption;

        return ((_item$componentOption = item.componentOptions) === null || _item$componentOption === void 0 ? void 0 : _item$componentOption.tag) === 'm-tab';
      })) || [];
    };

    var setCurrentIndex = function setCurrentIndex(currentIndex) {
      // 这个先保留吧，这个是vant用来滚动导航的，我这用不到
      // const newIndex = findAvailableTab(currentIndex);
      // if (newIndex === undefined) {
      //     return;
      // }
      var newIndex = !state.tabList[currentIndex].disabled ? currentIndex : 0;
      state.currentIndex = newIndex;
      var newTab = state.tabList[newIndex];
      var newName = getTabName(newTab);

      if (newName !== props.active) {
        emit('update', newName);

        if (state.currentIndex !== null) {
          emit('change', newName, newTab.title);
        }

        if (props.scroll) {
          root.$nextTick(function () {
            root.$nextTick(function () {
              scrollIntoView(props.scrollAnimate);
            });
          });
        }
      } else if (props.scroll) {
        root.$nextTick(function () {
          root.$nextTick(function () {
            scrollIntoView(false);
          });
        });
      }

      if (props.swiperable) {
        contentMove(newIndex);
      }
    };

    var setCurrentIndexByName = function setCurrentIndexByName(name) {
      var matched = state.tabList.find(function (item) {
        return item.name === name;
      });
      var index = matched ? state.tabList.indexOf(matched) : 0;
      setCurrentIndex(index);
    };

    var tabRefs = ref([]);
    var titleRefs = ref([]);
    var tabOffsetWidthList = computed(function () {
      var _tabRefs$value;

      var list = [];
      (_tabRefs$value = tabRefs.value) === null || _tabRefs$value === void 0 ? void 0 : _tabRefs$value.forEach(function (val) {
        list.push(val.offsetWidth);
      });
      return list;
    });

    var setRefs = function setRefs() {
      state.tabList.forEach(function (item, index) {
        root.$set(tabRefs.value, index, refs["tabRef-".concat(index)]);
        root.$set(titleRefs.value, index, refs["titleRef-".concat(index)]);
      });
    };

    var slideInstance = computed(function () {
      var instance = 0;

      if (tabRefs.value[state.currentIndex]) {
        var _tabRefs$value$state$;

        instance = (_tabRefs$value$state$ = tabRefs.value[state.currentIndex]) === null || _tabRefs$value$state$ === void 0 ? void 0 : _tabRefs$value$state$.offsetLeft;
      }

      return instance;
    });
    var slideStyle = computed(function () {
      var _tabRefs$value$state$2;

      var translate = "translate(".concat(slideInstance.value, "px,0)");
      return {
        transform: translate,
        width: "".concat((_tabRefs$value$state$2 = tabRefs.value[state.currentIndex]) === null || _tabRefs$value$state$2 === void 0 ? void 0 : _tabRefs$value$state$2.offsetWidth, "px")
      };
    });
    var slideLineStyle = computed(function () {
      if (!props.fill) {
        var _titleRefs$value$stat;

        return {
          width: "".concat(((_titleRefs$value$stat = titleRefs.value[state.currentIndex]) === null || _titleRefs$value$stat === void 0 ? void 0 : _titleRefs$value$stat.offsetWidth) + 32, "px")
        };
      }

      return {
        width: '100%'
      };
    });

    var renderLine = function renderLine() {
      if (!props.hideLine) {
        var _titleRefs$value$stat2, _tabRefs$value$state$3;

        return h("div", {
          "style": slideStyle.value,
          "class": "m-tabs-slide"
        }, [slots.line ? slots.line({
          titleWidth: (_titleRefs$value$stat2 = titleRefs.value[state.currentIndex]) === null || _titleRefs$value$stat2 === void 0 ? void 0 : _titleRefs$value$stat2.offsetWidth,
          tabWidth: (_tabRefs$value$state$3 = tabRefs.value[state.currentIndex]) === null || _tabRefs$value$state$3 === void 0 ? void 0 : _tabRefs$value$state$3.offsetWidth
        }) : h("div", {
          "class": "m-tabs-slide-line",
          "style": slideLineStyle.value
        })]);
      }
    };

    var tabStyle = computed(function () {
      return props.fill ? {} : {
        padding: '0 16px'
      };
    });
    var rtlLanguages = ['ar', 'ur'];

    var getIsRtl = function getIsRtl() {
      var isRtl = props.isRtl;
      var locale = navigator.language.split('-')[0] || 'en';

      if (rtlLanguages.includes(locale)) {
        isRtl = true;
      }

      return isRtl;
    };

    var isRtl = getIsRtl();

    var scrollIntoView = function scrollIntoView(scrollAnimate) {
      var wrapper = refs.wrapperRef;
      var titles = titleRefs.value;

      if (!wrapper || !titles) {
        return;
      }

      var wrapperScrollLeft = wrapper.scrollLeft;
      var title = titles[state.currentIndex];
      var titleOffsetWidth = title.offsetWidth;
      var titleOffsetLeft = title.offsetLeft; // wrapper的宽度和屏幕宽度一致
      // const windowWidth = document.body.clientWidth;

      var wrapperWidth = wrapper.offsetWidth;
      var wrapperRealWidth = tabOffsetWidthList.value.reduce(function (prev, curr) {
        return prev + curr;
      }); // 要想active的元素在中间，想法就是wrapper.scrollLeft-active的OffsetLeft = (屏幕宽度-active的宽度)/2

      var to = titleOffsetLeft - (wrapperWidth - titleOffsetWidth) / 2;

      if (!scrollAnimate) {
        refs.wrapperRef.scrollLeft = to;
        return;
      }

      var start = wrapperScrollLeft; // 区分前进还是后退

      var isAdd = to - start > 0;

      if (isAdd) {
        var animate = function animate() {
          // 性能优化，防止它到头了还继续执行animate
          if (start + wrapperWidth > wrapperRealWidth) {
            return;
          }

          if (to - start > 0) {
            start += props.scrollSpeed;

            if (to - start <= 0) {
              // 为了精确
              start = to;
            }

            refs.wrapperRef.scrollLeft = start;
            window.requestAnimationFrame(animate);
          }
        };

        window.requestAnimationFrame(animate);
      } else {
        var _animate = function _animate() {
          // 性能优化，防止它到头了还继续执行animate
          if (!isRtl && start < 0) {
            return;
          }

          if (start - to > 0) {
            start -= props.scrollSpeed;

            if (start - to <= 0) {
              // 为了精确
              start = to;
            }

            refs.wrapperRef.scrollLeft = start;
            window.requestAnimationFrame(_animate);
          }
        };

        window.requestAnimationFrame(_animate);
      }
    };

    var handleTabClick = function handleTabClick(item, index, event) {
      var name = getTabName(item);

      if (item.disabled) {
        emit('disabled', name, item.title);
      } else {
        setCurrentIndex(index);
      }

      emit('click', name, item.title, item.disabled);
    };

    var handleStickyScroll = function handleStickyScroll(_ref2) {
      var scrollTop = _ref2.scrollTop,
          isFixed = _ref2.isFixed;
      emit('scroll', scrollTop, isFixed);
    };

    var isInTouch = ref(true);
    var touches = {
      startX: 0,
      startTime: 0,
      startY: 0,
      minDistance: 20
    }; // 计算是否满足滑动条件

    function isValidTouch(e) {
      var currentX = e.changedTouches[0].pageX;
      var currentY = e.changedTouches[0].pageY;
      var maxIndex = state.tabList.length - 1;
      if (maxIndex <= 0) return false;
      var diffX = currentX - touches.startX;
      var diffY = currentY - touches.startY;
      var absDistance = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)); // 当前触摸移动距离小于设定的最小值时不满足滑动条件

      if (absDistance < touches.minDistance) return false; // 在滑动过程中检测滑动角度是否满足角度阈值

      return true;
    }

    function onTouchstart(e) {
      isInTouch.value = true; // 处理快速滚动边界item换位中断

      touches.startX = e.changedTouches[0].pageX;
      touches.startY = e.changedTouches[0].pageY;
      touches.startTime = new Date().getTime();
    }

    function onTouchmove(e) {
      isInTouch.value = false;

      if (props.swiperType === 2) {
        var currentInstance = state.currentIndex * (isRtl ? 100 : -100);
        var bodyWidth = document.body.offsetWidth; // 跟随手指

        trackMoveInstancePercent.value = currentInstance + (e.changedTouches[0].pageX - touches.startX) * 100 / bodyWidth;
      }
    } // 获得角度


    function getAngle(angx, angy) {
      return Math.atan2(angy, angx) * 180 / Math.PI;
    } // 根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动


    function getDirection(startx, starty, endx, endy) {
      var angx = endx - startx;
      var angy = endy - starty;
      var result = 0; // 如果滑动距离太短

      if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
        return result;
      }

      var angle = getAngle(angx, angy);

      if (angle >= -150 && angle <= -30) {
        result = 1;
      } else if (angle > 30 && angle < 150) {
        result = 2;
      } else if (angle >= 150 && angle <= 180 || angle >= -180 && angle < -150) {
        result = 3;
      } else if (angle >= -30 && angle <= 30) {
        result = 4;
      }

      return result;
    }

    function onTouchend(e) {
      if (!isValidTouch(e)) {
        return;
      }

      var diffIndex = 0;
      var touch = e.changedTouches[0];

      if (touch.pageX !== touches.startX) {
        diffIndex = touch.pageX > touches.startX ? -1 : 1;
      }

      if (isRtl) {
        diffIndex = -diffIndex;
      }

      var interval = new Date().getTime() - touches.startTime; // 横向滚动距离

      var transverseDistance = Math.abs(touch.pageX - touches.startX);
      var transverseSpeed = transverseDistance / interval;
      var speedThreshold = 0.4;
      var resetFlag = props.swiperType === 2 && transverseSpeed <= speedThreshold; // 就是滚动类型为2并且速度不快的话就不让其滚到下一个

      if (resetFlag) {
        diffIndex = 0;
      }

      var verticalDistance = Math.abs(touch.pageY - touches.startY);
      var directionResult = getDirection(touches.startX, touches.startY, touch.pageX, touch.pageY);
      var isVertical = directionResult === 1 || directionResult === 2 || isScroll.value;

      if (isVertical) {
        diffIndex = 0;
      }

      isInTouch.value = false;
      var nextIndex = state.currentIndex + diffIndex;

      if (nextIndex >= state.tabList.length || nextIndex < 0) {
        diffIndex = 0;
      }

      setCurrentIndex(state.currentIndex + diffIndex);
    }

    var isScroll = ref(false);
    var timer;

    function handleScroll(e) {
      isScroll.value = true;

      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(function () {
        isScroll.value = false;
      }, 500);
    }

    document.addEventListener('scroll', handleScroll);

    var unDef = function unDef() {};

    var contentMove = function contentMove(index) {
      isInTouch.value = true;
      trackMoveInstancePercent.value = index * (isRtl ? 100 : -100);
    };

    var trackMoveInstancePercent = ref(0);
    var trackStyle = computed(function () {
      if (props.swiperType === 3) {
        return {};
      }

      return {
        transform: "translate3d(".concat("".concat(trackMoveInstancePercent.value, "%"), ", 0, 0)")
      };
    });
    onMounted(function () {
      initTabs();
    });

    var onRendered = function onRendered(name, title) {
      emit('rendered', name, title);
    };

    var renderHeader = function renderHeader() {
      return h("div", {
        "ref": "wrapperRef",
        "class": "m-tabs-wrapper ".concat(props.scroll ? 'm-tabs-wrapper--scroll' : '')
      }, [state.tabList.map(function (item, index) {
        var _item$paneInstance, _item$paneInstance2;

        return h("div", {
          "ref": "tabRef-".concat(index),
          "key": "".concat(item.name).concat(index),
          "style": tabStyle,
          "on": {
            "click": function click(event) {
              return handleTabClick(item, index, event);
            }
          },
          "class": {
            'm-tab': true,
            'm-tab--active': currentName.value === item.name,
            'm-tab--fill': props.fill,
            'm-tab--unfill': !props.fill,
            'm-tab--disabled': item.disabled
          }
        }, [h("span", {
          "ref": "titleRef-".concat(index),
          "class": "m-tab-title"
        }, [(_item$paneInstance = item.paneInstance) !== null && _item$paneInstance !== void 0 && _item$paneInstance.$slots.title ? (_item$paneInstance2 = item.paneInstance) === null || _item$paneInstance2 === void 0 ? void 0 : _item$paneInstance2.$slots.title : item.title])]);
      }), renderLine()]);
    };

    provide(TABS_KEY, {
      props: props,
      updateChildrenTablist: updateChildrenTablist,
      onRendered: onRendered
    });
    return function () {
      var _slots$default2, _slots$default3;

      return h("div", {
        "attrs": {
          "dir": isRtl ? 'rtl' : 'ltr'
        },
        "class": {
          'm-tabs': true,
          'm-tabs--dark': props.theme === 'dark'
        }
      }, [props.sticky ? h(Sticky, {
        "attrs": {
          "offsetTop": props.offsetTop
        },
        "on": {
          "scroll": handleStickyScroll
        }
      }, [renderHeader()]) : renderHeader(), h("div", {
        "class": {
          'm-tabs__content': true,
          'm-tabs__content--animated': props.swiperable
        },
        "on": {
          "touchstart": props.swiperable ? onTouchstart : unDef,
          "touchmove": props.swiperable ? onTouchmove : unDef,
          "touchend": props.swiperable ? onTouchend : unDef
        }
      }, [props.swiperable && props.swiperType !== 3 ? h("div", {
        "class": {
          'm-tabs__track': true,
          'm-tabs__track--animated': isInTouch.value
        },
        "style": trackStyle.value
      }, [(_slots$default2 = slots["default"]) === null || _slots$default2 === void 0 ? void 0 : _slots$default2.call(slots)]) : (_slots$default3 = slots["default"]) === null || _slots$default3 === void 0 ? void 0 : _slots$default3.call(slots)])]);
    };
  }
});
withInstall(Tabs);
export default Tabs;